<div class="main_section mt-5 mb-2 pl-8 pr-8 " id="partnerContent">
  <!-- Navtabs -->
  <ul class="nav nav-tabs" *ngIf="!showView && !showReview && !showAttrView">
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" (click)="setIndex(0)" [ngClass]="{'active': tabIndex === 0}">
        <span i18n="@@partner-content.anchor-text.review-content">REVIEW CONTENT</span></a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" (click)="setIndex(1)" [ngClass]="{'active': tabIndex === 1}">
        <span i18n="@@partner-content.anchor-text.approve-content">APPROVED CONTENT</span></a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" (click)="setIndex(2)" [ngClass]="{'active': tabIndex === 2}">
        <span i18n="@@partner-content.anchor-text.partner">PARTNERS</span>
      </a>
    </li>
    <li class="nav-item">
      <a *ngIf="!isAuthorDisabled" class="nav-link" data-toggle="tab" (click)="setIndex(3)"
        [ngClass]="{'active': tabIndex === 3}">
        <span i18n="@@partner-content.anchor-text.authors">AUTHORS</span>
      </a>
      <span *ngIf="isAuthorDisabled" class="nav-link" data-toggle="tab"
        [ngClass]="{'author-disabled': isAuthorDisabled }" [ngbTooltip]='authorDisabledMsg'>
        <span i18n="@@partner-content.anchor-text.authors">AUTHORS</span>
      </span>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" (click)="setIndex(4)" [ngClass]="{'active': tabIndex === 4}">
        <span>SYSTEM IDS</span>
      </a>
    </li>
  </ul>
  <div class="tab-content" *ngIf="!showView && !showReview && !showAttrView" id="partnerConTab">
    <div *ngIf="tabIndex === 0" class="tab-pane" [ngClass]="{'active': tabIndex === 0}" id="partnerTabPane0">
      <iposcen-review-partner-content (enableComments)='isCommentEnabled=$event' (sendPartner)='partnerData = $event'
        (autoID)="autoID = $event" (autoID)="autoID = $event" (adminRef)="adminRef = $event"
        (attrViewOpen)="showAttrView = $event" (attrID)="attractID = $event" (pid)="pid = $event"
        (contentID)="contentID = $event" (reviewOn)="showReviews($event)" [selectedPartnerName]="selectPartner"
        [checkReviewStatus]="checkStatus" [contentsInfo]="contentsData"></iposcen-review-partner-content>
    </div>
    <div *ngIf="tabIndex === 1" class="tab-pane" [ngClass]="{'active': tabIndex === 1}" id="partnerTabPane1">
      <iposcen-approved-partner-content (autoID)="autoID = $event" (contentID)="contentID = $event"
        (attrID)="attractID = $event" [isPartnerTabActive]="isPartnerTabActive" (pid)="pid = $event"
        (adminRef)="adminRef = $event" (attrViewOpen)="showAttrView = $event" (viewOn)="showView = $event"
        [selectedPartnerName]="selectPartner" [checkReviewStatus]="checkStatus" [checkViewStatus]="checkStatusView"
        [contentsInfo]="contentsData">
      </iposcen-approved-partner-content>
    </div>
    <div *ngIf="tabIndex === 2" class="tab-pane" [ngClass]="{'active': tabIndex === 2}" id="partnerTabPane2">
      <iposcen-partners></iposcen-partners>
    </div>
    <div *ngIf="tabIndex === 3" class="tab-pane" [ngClass]="{'active': tabIndex === 3}" id="partnerTabPane3">
      <iposcen-authors></iposcen-authors>
    </div>
    <div *ngIf="tabIndex === 4" class="tab-pane" [ngClass]="{'active': tabIndex === 4}" id="partnerTabPane4">
      <iposcen-system-ids></iposcen-system-ids>
    </div>
  </div>
  <div *ngIf="showView" class="tab-pane" id="showViewCon">
    <iposcen-approved-partner-content-view (selectButton)='selectPartner=$event' (contentsData)="contentsData=$event"
      (checkStatus)="checkStatus=$event" (viewOn)='showView=$event' [autoID]="autoID" [contentID]=" contentID">
    </iposcen-approved-partner-content-view>
  </div>

  <div *ngIf='showReview' class="tab-pane" id="showReviewCon">
    <iposcen-review-comment [partnerDataReview]='partnerData' (selectButton)='selectPartner=$event'
      (contentsData)="contentsData=$event" (checkStatus)="checkStatus=$event" (reviewOn)='showReview=$event'
      [autoID]="autoID" [contentID]=" contentID" (returnBack)='tabIndexSet($event)'></iposcen-review-comment>
  </div>

  <div *ngIf="showAttrView" class="tab-pane" id="showAttrView">
    <iposcen-view-attract-admin [commentEnabled]='isCommentEnabled' (checkStatusReView)="checkStatus=$event" (checkStatusView)="checkStatusView=$event"
      (selectButton)='selectPartner=$event' (attractorViewOn)='showAttrView=$event'
      (isPartnerTabActive)="isPartnerTabActive=$event" [pid]="pid" [adminRef]="adminRef" [attractorLoopId]="attractID">
    </iposcen-view-attract-admin>
  </div>
</div>